import packageJson from 'package.json';
import brandConfig from 'src/assets/brands/default/config.json';

export const environment = {
  production: true,
  name: 'test',
  appVersion: packageJson.version,
  brandConfig: brandConfig as unknown as Config,
  apiDomain: 'test.api.identi.pet',
  apiUrl: 'https://test.api.identi.pet',
  domain: 'test.identi.pet',
  canonicalUrl: 'https://test.identi.pet',
  adminLoginUrl: 'https://test.admin.identi.pet/Account/Account/Login',
  brandMainPageUrl: null,
  loginRedirectUrl: null,
  googleMapsApiKey: 'AIzaSyB1V1r4QFNAAWzJXNGHew65jgKPbUwxPfs',
  googleTagManagerId: 'GTM-WJ4Z563',
  iterablePublishableApiKey: '46f0339f45fa406f943651adad610bfd',
  segmentKey: '',
  perkShortCode: 'petplantrial',
  eligibilityShortCode: '',
  conversionSendToParam: 'W-17046233086/r57wCPLirMAaEP6_o8A_',
  stripePlans: {
    identibasePlus: 'price_1Qs39DGrKoMpYaks8dVXSnbh',
    identibasePlusCod: 'price_1Qs39YGrKoMpYaksFrZqdbx5',
    identiAlertMonthly: 'price_1Qs36uGrKoMpYaksEzyCv2Oz',
    identiAlertAnnual: 'price_1TmAB3GrKoMpYaksnjkJc1hf',
    identiAlertFind: 'price_1TmACCGrKoMpYakskEA8LcDi',
    identiAlertFindCat: 'price_1TmAC2GrKoMpYakskFA1m8ae',
    identiAlertTok: 'price_1TmABoGrKoMpYakswQQIBzbX',
    identiAlertTokBreeder: 'price_1TmABcGrKoMpYakseIesScz1',
    smartTagPhysicalProduct: 'price_1TbG2PGrKoMpYaksedHmyUYC',
    smartTagSubscription: 'price_1TZ93IGrKoMpYaks8Jbvqly4',
    atBasePlusB21KMandatory: 'price_1ToNpxGrKoMpYaks6tpYaCBW',
    atAlertB21KMandatory: 'price_1ToNoBGrKoMpYaksvAU6aF2C',
    atIdentiAlertTok: 'price_1TmABoGrKoMpYakswQQIBzbX',
    atIdentibasePlusCod: 'price_1Qs39YGrKoMpYaksFrZqdbx5',
  },
  isB2CLoginEnabled: false,
  msalConfig: {
    clientId: '',
    authorities: {
      signUpSignIn: '',
    },
  },
};
